<style>
.is-invalid  .v-select  .vs__dropdown-toggle{
      border-color: #f46a6a;
}
</style>
<script>
import {
  required, requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      form:{
       type:'g',
      },
      bayiList:[],
      address:{},
      title:'',
      checkUsername:false,
      loadingBasvuru:false,
      loadingChurn:false,
      loadingTelekom:false,
      telekomList:[],
      submitted: false,
    };
  },
  validations: {
    form: {
      xdsl: {
        required: requiredIf(function () {
            return this.address.isChurn
        })
      },
      taxnum: {
        required: requiredIf(function () {
            return this.form.type == 't'
        })
      },
      taxoffice: {
        required: requiredIf(function () {
            return this.form.type == 't'
        })
      },
      companyname: {
        required: requiredIf(function () {
            return this.form.type == 't'
        })
      },
      tc: { required },
      phonenumber: { required },
      fname: { required },
      lname: { required },
      tariff: { required },
      username: { required },
      password: { required },
    },
  },
  watch:{
    list(props){
      this.title = props.isChurn ? 'Yeni Churn Girişi' : 'Yeni Abonelik Girişi'
      this.address = {...props}
    }
  },
  mounted(){
     this.$http.get('/dealers/search?output=json')
      .then(resp => {
            this.bayiList = resp.data
        })
      .catch(error => error)
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
     if (this.$v.$invalid) {
        return;
      } else {
        this.create();
      }
      this.submitted = false;
    },
    create(){
      let payload = {}
      let url=''
      if(this.address.isChurn){
        this.loadingChurn = true
        payload = { ...this.form }
        url = "/vae/churn/store"
      }else{
        this.loadingBasvuru = true
        payload = { ...this.form,bbk:this.address.bbk,address:this.address.address }
        url = "/vae/createCustomer"
      }
       
      this.$http.post(url, payload)
                .then((response) => { 
                    if(response.data.error) return notify.error(response.data.message)
                      notify.success(response.data.message)
                })
                .catch(error => error)
                .finally(() => this.address.isChurn ? this.loadingChurn = false :  this.loadingBasvuru = false)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },
    tariff({target}){
        this.loadingTelekom = true
        this.$http.post(`/vae/tariff`, { type:target.value })
        .then((response) => { 
            this.telekomList = response.data
        })
        .catch(error => error)
        .finally(() => this.loadingTelekom=false)
    },
    getCheckUsername(){
      if(!this.form.username) return
      this.$http.post(`/vae/userCheck`, { username:this.form.username })
      .then((response) => { 
        if(response.data.error)  return notify.error(response.data.message)
        this.checkUsername = true
        notify.success(response.data.message)
      })
      .catch(error => error)
    }
  },
};
</script>

<template>
  <b-modal 
        id="modal-scoped"
        :title="title"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="form-group row mb-3 bg-primary py-1" v-if="address.isChurn">
          <label class="col-sm-6 col-form-label text-light">Xdsl No</label>
          <div class="col-sm-6">
          <input
            v-model="form.xdsl"
            type="text"
            class="form-control"
            placeholder="Xdsl No"
            :class="{
                'is-invalid': submitted && $v.form.xdsl.$error,
            }"
            />
              </div>
          <div
            v-if="submitted && !$v.form.xdsl.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <nav>
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link" @click="form.type='g'" :class="{active:form.type=='g'}" href="javascript:void(0);">Gerçek Müşteri</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" @click="form.type='t'" :class="{active:form.type=='t'}" href="javascript:void(0);">Tüzel Müşteri</a>
                  </li>
                </ul>
            </nav>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <div class="mb-3">
              <label>Bayi</label>
              <select v-model="form.user_id" class="form-select form-select-sm" >
                <option :value="bayi.id" v-for="bayi in bayiList" :key="bayi.id">{{ bayi.name }}</option>
              </select>
              <div
                v-if="submitted && !$v.form.tc.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
         <div class="row mt-2">
          <div class="col-md-6">
            <div class="mb-3" v-if="form.type=='g'">
              <label>Tc No</label>
              <input
                v-model="form.tc"
                type="text"
                class="form-control"
                placeholder=""
                :class="{
                    'is-invalid': submitted && $v.form.tc.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.tc.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
            <div class="mb-3" v-else>
              <label>Vkn</label>
              <input
                v-model="form.taxnum"
                type="text"
                class="form-control"
                placeholder=""
                :class="{
                    'is-invalid': submitted && $v.form.taxnum.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.taxnum.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-md-6"  v-if="form.type=='t'">
            <div class="mb-3">
              <label>Vergi Dairesi</label>
              <input
                v-model="form.taxoffice"
                type="text"
                class="form-control"
                placeholder=""
                :class="{
                    'is-invalid': submitted && $v.form.taxoffice.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.taxoffice.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
           <div class="col-md-6">
            <div class="mb-3">
              <label>Telefon</label>
              <input
                v-model="form.phonenumber"
                type="text"
                class="form-control"
                placeholder="Telefon"
                :class="{
                    'is-invalid': submitted && $v.form.phonenumber.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.phonenumber.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
         <div class="row" v-if="form.type=='g'">
          <div class="col-md-6">
            <div class="mb-3">
              <label>İsim</label>
              <input
                v-model="form.fname"
                type="text"
                class="form-control"
                placeholder="İsim"
                :class="{
                    'is-invalid': submitted && $v.form.fname.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.fname.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label>Soyisim</label>
              <input
                v-model="form.lname"
                type="text"
                class="form-control"
                placeholder="Soyisim"
                :class="{
                    'is-invalid': submitted && $v.form.lname.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.lname.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-12">
            <div class="mb-3">
              <label>Müşteri Ünvan</label>
              <input
                v-model="form.companyname"
                type="text"
                class="form-control"
                placeholder="Müşteri Ünvan"
                :class="{
                    'is-invalid': submitted && $v.form.companyname.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.companyname.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label>Kullanıcı Adı</label>
              <div class="input-group mb-3">
                <input
                  v-model="form.username"
                  type="text"
                  class="form-control"
                  placeholder="Kullanıcı Adı"
                  :class="{
                      'is-invalid': submitted && $v.form.username.$error,
                  }"
                  />
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-info">
                      <i class="mdi mdi-account-check-outline" @click.prevent="getCheckUsername()"></i>
                    </button>
                </div>
                <div
                    v-if="!checkUsername"
                    class="invalid-feedback"
                    style="display:block"
                  >
                  Bu alanı doldurmak zorunludur.
                  </div>
              </div>
              <div
                v-if="submitted && !$v.form.username.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label>Şifre</label>
              <input
                v-model="form.password"
                type="text"
                class="form-control"
                placeholder="Şifre"
                :class="{
                    'is-invalid': submitted && $v.form.password.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.password.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label>Tarife Türü</label>
              <select 
                  class="form-select form-select-sm" 
                  @change="tariff($event)"
                  v-model="form.tariff_type"
                >
                  <option value="">Seçiniz</option>
                  <option value="1">ADSL</option>
                  <option value="6">VDSL</option>
                  <option value="7">Fiber</option>
                </select>
            </div>
          </div>
          <div class="col-8">
            <div class="mb-3">
              <label>Tarife </label>
                <v-select
                    :loading="loadingTelekom"
                    label="name" 
                    v-model="form.tariff"
                    :reduce="data=>data.id"
                    :options="telekomList">
                    <span slot="no-options">Sonuç Bulunamadı</span>
                    <template #spinner="{ loading }">
                      <div
                        v-if="loading"
                        style="border-left-color: rgba(88, 151, 251, 0.71)"
                        class="vs__spinner"
                      >
                        The .vs__spinner class will hide the text for me.
                      </div>
                    </template>
                </v-select>
              <div
                v-if="submitted && !$v.form.tariff.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <div>
            <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
          </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            :disable="loadingBasvuru"
            >Oluştur
              <span v-if="loadingBasvuru"> 
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Bekleyiniz 
            </span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>
</template>